/**
 * Generated runtime TestId mirror for frontend/src/components/attributes/TypeScopeSelector.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const TypeScopeSelectorTestIds = {
  typeScopeAdd: "type-scope-add",
  typeScopeAll: "type-scope-all",
  typeScopeSpecific: "type-scope-specific",
  typeScopeCheckbox: (type_code: string) => `type-scope-checkbox-${type_code}`,
  typeScopeCheckboxPrefix: () => "type-scope-checkbox-" as TestIdPrefix,
  typeScopeRemove: (type_code: string) => `type-scope-remove-${type_code}`,
  typeScopeRemovePrefix: () => "type-scope-remove-" as TestIdPrefix
} as const;
